var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDusk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.144 18.718a15.083 15.083 0 0 0 .097-4.832H8.72a.604.604 0 1 1 0-1.208H19.02C17.624 6.502 12.417 1.77 6 1.085A15.17 15.17 0 0 1 7.61 1c7.143 0 13.12 4.992 14.632 11.678h3.792a.604.604 0 1 1 0 1.208h-3.571a15.12 15.12 0 0 1-.098 4.832h3.669a.604.604 0 0 1 0 1.208h-3.942C20.366 26.306 14.537 31 7.61 31c-.543 0-1.08-.03-1.61-.086 6.206-.662 11.28-5.11 12.87-10.988H8.718a.604.604 0 0 1 0-1.208h10.426z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDusk);
export default __webpack_public_path__ + "static/media/DUSK.396089e5580e7b1d20df77bcd2d1bd74.svg";
export { ForwardRef as ReactComponent };